import React, { useState, useEffect, useContext } from 'react';
import { Link } from 'react-router-dom';
import '../style/Header.css';
import {
  FaUser, FaShoppingCart, FaSearch, FaBars, FaTimes,
  FaThLarge, FaBookOpen, FaHeadset, FaMapMarkerAlt, FaInfoCircle, FaHome
} from 'react-icons/fa';
import { MdLocationOn } from 'react-icons/md';
import logo from '../assets/logo.png';
import { ProductsContext } from "../components/ProductsContext"; // ✅ global cached products

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showCategories, setShowCategories] = useState(false);

  // 🔹 Search States
  const [searchTerm, setSearchTerm] = useState("");
  const [searchFocused, setSearchFocused] = useState(false); // ✅ new
  const allProducts = useContext(ProductsContext); // ✅ cached products
  const [searchResults, setSearchResults] = useState([]);

  // 🔹 Top 3 categories (default suggestions)
  const topCategories = [
    { name: "Airconditioner" },
    { name: "Washing machines" },
    { name: "Televisions" },
  ];

  // 🔹 Search filter
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setSearchResults([]); 
      return;
    }
    if (!allProducts) return;

    const results = allProducts.filter((p) =>
      p.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.brand?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setSearchResults(results.slice(0, 6)); // max 6 suggestions
  }, [searchTerm, allProducts]);

  return (
    <>
      {/* Top Bar (Web only) */}
      <div className="top-bar">
        <div className="top-links">
          <a href="/"><FaHome /> Home </a>
          <a href="/aboutus"><FaInfoCircle /> About Us</a>
          <a href="/storelocator"><FaMapMarkerAlt /> Store Locator</a>
          <a href="/topbrands"><FaThLarge /> Top Brands</a>
          <a href="/ecatalogue"><FaBookOpen /> E-Catalogue</a>
          <a href="/customersupport"><FaHeadset /> Customer Support</a>
        </div>
      </div>

      {/* Mobile Header */}
      <div className="mobile-header">
        <FaBars className="hamburger" onClick={() => setMenuOpen(true)} />
        <div className="logo-wrapper">
          <Link to="/">
            <img src={logo} alt="Great Eastern Logo" className="site-logo" />
          </Link>
        </div>
        <div className="mobile-icons">
          <FaUser className="iconm" />
          <FaShoppingCart className="iconm" />
        </div>
      </div>

      {/* Mobile Search */}
      <div className="mobile-search-box">
        <input
          type="text"
          placeholder="Search for products, brands & more"
          value={searchTerm}
          onFocus={() => setSearchFocused(true)}   // ✅ show dropdown on focus
          onBlur={() => setTimeout(() => setSearchFocused(false), 200)} // ✅ hide on blur (with delay for click)
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <button><FaSearch /></button>

        {/* 🔹 Mobile Search Suggestions */}
        {searchFocused && (searchTerm ? (
          <div className="search-dropdown mobile-only">
            {searchResults.length > 0 ? (
              searchResults.map((item) => (
                <Link
                  to={`/category/${item.category}?highlight=${item.id}`}
                  key={item.id}
                  className="search-item"
                  onClick={() => setSearchTerm("")}
                >
                  <img src={item.image} alt={item.title} />
                  <div>
                    <p className="title">{item.title}</p>
                    <p className="price">₹{item.price?.toLocaleString()}</p>
                  </div>
                </Link>
              ))
            ) : (
              <div className="search-item no-results">No results found</div>
            )}
          </div>
        ) : (
          // 🔹 Default Top Categories when no search
          <div className="search-dropdown mobile-only">
            {topCategories.map((cat) => (
              <Link
                to={`/category/${cat.name}`}
                key={cat.name}
                className="search-item"
                onClick={() => setSearchTerm("")}
              >
                <div>
                  <p className="title">{cat.name}</p>
                </div>
              </Link>
            ))}
          </div>
        ))}
      </div>

      {/* Hamburger Menu (Mobile) */}
      {menuOpen && (
        <div className="mobile-menu">
          <div className="menu-header">
            <img src={logo} alt="Logo" />
            <FaTimes className="close-icon" onClick={() => setMenuOpen(false)} />
          </div>
          <a href="/"><FaHome /> Home </a>
          <a href="/aboutus"><FaInfoCircle /> About Us</a>
          <a href="/storelocator"><FaMapMarkerAlt /> Store Locator</a>
          <a href="/topbrands"><FaThLarge /> Top Brands</a>
          <a href="/ecatalogue"><FaBookOpen /> E-Catalogue</a>
          <a href="/customersupport"><FaHeadset /> Customer Support</a>
        </div>
      )}

      {/* Main Header (Web only) */}
      <header className="header">
        <div className="header-left">
          <Link to="/">
            <img src={logo} alt="Great Eastern Logo" className="site-logo" />
          </Link>
        </div>

        <div className="header-center">
                    <div className="search-box">
                      <div
                        className="dropdown"
                        onMouseEnter={() => setShowCategories(true)}
                        onMouseLeave={() => setShowCategories(false)}
                      >
                        <button className="category-btn">All Categories ▾</button>
                       {showCategories && (
            <div className="dropdown-content">
              
          
              <div className="category-group">
                <div className="category-title">Home Appliances</div>
                <ul>
                  <li><Link to="/category/Airconditioner">Airconditioner</Link></li>
                  <li><Link to="/category/Televisions">Televisions</Link></li>
                  <li><Link to="/category/Refrigerators">Refrigerators</Link></li>
                  <li><Link to="/category/Microwaves">Microwaves</Link></li>
                  <li><Link to="/category/Washing machines">Washing machines</Link></li>
                  <li><Link to="/category/Geysers">Geysers</Link></li>
                  <li><Link to="/category/Kitchen appliances">Kitchen appliances</Link></li>
                  <li><Link to="/category/Water purifiers">Water purifiers</Link></li>
                  <li><Link to="/category/Cooler">Cooler</Link></li>
                </ul>
              </div>
          
              <div className="category-group">
                <div className="category-title">Gadgets</div>
                <ul>
                  <li><Link to="/category/Mobiles">Mobiles</Link></li>
                  <li><Link to="/category/Laptops">Laptops</Link></li>
                  <li><Link to="/category/Headphones & Earphones">Headphones & Earphones</Link></li>
                  <li><Link to="/category/Tablets">Tablets</Link></li>
                  <li><Link to="/category/Wearables">Wearables</Link></li>
                  <li><Link to="/category/Cameras">Cameras</Link></li>
                  <li><Link to="/category/Home theatre & soundbars">Home theatre & soundbars</Link></li>
                  <li><Link to="/category/Grooming">Grooming</Link></li>
                </ul>
              </div>
            </div>
          )}
          
                      </div>
          
                      <input
                        type="text"
                        placeholder="Search for products, brands & more"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      <button><FaSearch /></button>
          
                      {/* 🔹 Web Search Suggestions */}
                      {searchTerm && (
            <div className="search-dropdown desktop-only">
              {searchResults.length > 0 ? (
                searchResults.map((item) => (
                  <Link
            to={`/category/${item.category}?highlight=${item.id}`}
            key={item.id}
            className="search-item"
            onClick={() => setSearchTerm("")}
          >
            <img src={item.image} alt={item.title} />
            <div>
              <p className="title">{item.title}</p>
              <p className="price">₹{item.price?.toLocaleString()}</p>
            </div>
          </Link>
          
                ))
              ) : (
                <div className="search-item no-results">
                  No results found
                </div>
              )}
            </div>
          )}
         </div>           
        </div>

        <div className="header-right">
          <div className="location"><MdLocationOn /> <span>Kolkata</span></div>
          <div className="iconw"><FaUser /></div>
          <div className="iconw"><FaShoppingCart /></div>
        </div>
      </header>

      {/* ✅ Spacer */}
      <div className="header-spacer"></div>
    </>
  );
};

export default Header;
